import React from "react";
import { Typography, Card, Form, Checkbox, Row, Col, Divider, Descriptions } from "antd";
import { Link } from "react-router-dom";
import NeedHelpIcon from "../NeedHelpIcon/NeedHelpIcon";
import { CreateCompanyData } from "../CreateCompanyProfile";

const { Title, Paragraph } = Typography;
interface Props {
  values: CreateCompanyData | undefined;
}

const StepSummary: React.FC<Props> = ({ values }) => {
  return (
    <Card style={{ width: "100%", minHeight: "500px" }}>
      <Row style={{ justifyContent: "space-between", width: "100%" }}>
        <Col>
          <Title level={3}>Oppsumering</Title>
        </Col>
        <Col>
          <NeedHelpIcon />
        </Col>
      </Row>

      <Descriptions title="Om bedriften">
        <Descriptions.Item label="Bedriftsnavn">{values?.name}</Descriptions.Item>
        <Descriptions.Item label="Organisasjonsnummer">{values?.organization_number}</Descriptions.Item>
      </Descriptions>
      <Descriptions title="Kontaktperson" style={{ marginTop: "1em" }}>
        <Descriptions.Item label="Navn">
          {values?.first_name} {values?.last_name}
        </Descriptions.Item>
        <Descriptions.Item label="E-post">{values?.companyContactEmail}</Descriptions.Item>
      </Descriptions>
      <Descriptions title="Bruker" style={{ marginTop: "1em" }}>
        <Descriptions.Item label="Brukernavn">{values?.username}</Descriptions.Item>
      </Descriptions>

      <Divider style={{ marginTop: "2em" }} />
      <Form.Item
        name="agreement"
        label="Vilkår"
        valuePropName="checked"
        rules={[
          {
            required: true,
            validator: (_, value) =>
              value ? Promise.resolve() : Promise.reject(new Error("Du må godta brukervilkårene")),
          },
        ]}
      >
        <Checkbox>
          <Paragraph style={{ margin: 0, cursor: "default" }}>
            Jeg godtar Bindeleddet NTNU sine{" "}
            <Link
              to="/user-terms/"
              target="_blank"
              style={{ fontStyle: "italic", fontWeight: "bold", textDecoration: "underline" }}
            >
              {/* TODO should we have company user terms? or a combined with students as today? */}
              brukervilkår
            </Link>
            .
          </Paragraph>
        </Checkbox>
      </Form.Item>
    </Card>
  );
};

export default StepSummary;
